import jQuery from 'jquery';

export function ajaxMarkup(...args) {
    return jQuery.ajax(...args)
        .then(
            data => data,
            (failResponse) => {
                if (failResponse.getResponseHeader('X-RP-INCOMPLETE') === 'yes') {
                    return jQuery.Deferred().resolve(failResponse.responseText).promise();
                }

                return jQuery.Deferred().reject(failResponse).promise();
            });
}



// WEBPACK FOOTER //
// ./lib/js/helpers/ajax.js